import React, { useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import { columnsNames } from "../../css/columns";
import { useDispatch, useSelector } from "react-redux";

const ColumnMenu = ({ columns, setColumns, setColumnMenu }) => {
  function addColumn(columns, newColumn) {
    columns[Object.keys(columns).length - 1] = newColumn;
    columns[Object.keys(columns).length] = "Valider";
    return columns;
  }

  const [columnFilter, setColumnFilter] = useState("");

  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  return (
    <div className="w-full h-full fixed flex justify-end items-center">
      <div className="mr-[30px] mt-[40px] w-[370px] h-[450px] bg-white shadow border-[1px]  border-[#BEC4CA] relative z-50 rounded-xl">
        <div className="h-[80px] w-full flex items-center justify-evenly">
          <input
            placeholder="Rechercher un indicateur d'impact"
            className="p-[20px] w-[300px] h-[30px] rounded-xl text-gray-500 bg-[#BEC4CA]/20"
            onChange={(event) => {
              let result = event.target.value;
              result = result.toLocaleLowerCase();
              setColumnFilter(result);
            }}
          />
          <button
            onClick={() => {
              setColumnMenu(0);
            }}
          >
            <Cross height={20} />
          </button>
        </div>
        <div className="font-Poppins-Regular text-xs overflow-y-auto overflow-hidden h-[370px]">
          {impact_indicators
            .filter((x) => !columns.includes(x.id))
            .map((current, i) => {
              if (current.name.fr.toLocaleLowerCase().includes(columnFilter)) {
                return (
                  <div key={`${current}${i}`}>
                    <button
                      onClick={() => {
                        setColumns([...columns, current.id]);
                        toast.success(
                          <div className="flex justify-between items-center">
                            <p>Ajout de l'indicateur {current.name.fr}</p>
                            {/* <button
                              className="bg-mainGreen py-[5px] px-[10px] text-sm text-white rounded-lg"
                              onClick={() => {
                                setColumns(columns);
                                setColumnMenu(true);
                              }}
                            >
                              Annuler
                            </button> */}
                          </div>
                        );
                        setColumnMenu(false);
                      }}
                      className="h-[30px] w-full text-left ml-[10px] hover:bg-[#BEC4CA]/20"
                    >
                      {current.name.fr}
                    </button>
                  </div>
                );
              }
            })}
        </div>
      </div>
    </div>
  );
};

export default ColumnMenu;
